import { FunctionComponent } from 'preact';
import searchIconSVG from 'icons/search.svg';
import { ReactSVG } from 'react-svg';
import {
  InstructionWrapper,
  InstructionText,
} from './PostalCodeInstruction.styles';

interface PostalCodeInstructionProps {
  text: string;
}

const PostalCodeInstruction: FunctionComponent<PostalCodeInstructionProps> = ({
  text,
}): JSX.Element => {
  return (
    <InstructionWrapper>
      <ReactSVG src={searchIconSVG} width={32} height={32} aria-hidden />
      <InstructionText>{text}</InstructionText>
    </InstructionWrapper>
  );
};

export { PostalCodeInstruction };
